import { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { ReactElement, ReactNode } from 'react'

const useStyles = makeStyles((theme: Theme) => {
  return {
    cardContainer: {
      borderRadius: theme.shape.borderRadius,
      overflow: 'hidden',
      width: '100%',
      // TODO: boxShadow values should eventually be added to the theme object after design decision
      '&.edgeStyle_overlay': {
        boxShadow: '0 0 6px 0 rgb(0 0 0 / 25%)',
      },
      '&.edgeStyle_card': {
        boxShadow: '0 4px 8px 0 rgb(0 0 0 / 8%)',
      },
      '&.edgeStyle_border': {
        border: `1px solid ${theme.palette.grey[400]}`,
      },
      '&.edgeStyle_flat': {
        border: 'none',
      },
    },
    header: {
      borderBottom: `1px solid ${theme.palette.grey[400]}`,
      padding: theme.spacing(6, 4),
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(6),
      },
    },
    content: {
      padding: theme.spacing(6, 4),
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(6),
      },
    },
    greyBackground: {
      background: theme.palette.background.grey,
    },
    whiteBackground: {
      background: theme.palette.background.default,
    },
  }
})

type CardContainerEdgeStyle = 'overlay' | 'card' | 'border' | 'flat'

interface CommonCardProps {
  edgeStyle?: CardContainerEdgeStyle
  greyBackground?: boolean
  headerMessage?: ReactElement
  overrideClasses?: {
    card?: string
    content?: string
  }
  children: ReactNode
}

const CommonCard = ({
  edgeStyle = 'card',
  greyBackground = false,
  headerMessage,
  overrideClasses,
  children,
}: CommonCardProps) => {
  const classes = useStyles()

  return (
    <div
      className={clsx([
        classes.cardContainer,
        overrideClasses?.card,
        `edgeStyle_${edgeStyle}`,
        {
          [classes.greyBackground]: greyBackground,
          edgeStyle_border: headerMessage,
        },
      ])}
    >
      {headerMessage && (
        <div className={clsx([classes.header, classes.greyBackground])}>
          {headerMessage}
        </div>
      )}

      <div
        className={clsx([classes.content, overrideClasses?.content], {
          [classes.whiteBackground]: headerMessage,
        })}
      >
        {children}
      </div>
    </div>
  )
}

export default CommonCard
